import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SeoRoutingModule } from './seo-routing.module';
import { SeoSummaryComponent } from './summary/summary.component';
import { SeoIssuesComponent } from './issues/issues.component';
import { SeoPagesComponent } from './pages/pages.component';
import { PagesSeoIssuesComponent } from './issues/seo-issues/pages-seo-issues.component';
import { SeoDialogPagesWithDuplicateTitleComponent } from './dialogs/pages-with-duplicate-title/seo-dialog-pages-with-duplicate-title.component';
import { SeoSummaryCommonOpportunitiesComponent } from './summary/blocks/common-opportunities/common-opportunities.component';
import { SeoIssuesBtnGroupComponent } from './components/seo-issues-btn-group/seo-issues-btn-group.component';
import { SeoSummaryOpportunitiesInCategoryComponent } from './summary/blocks/opportunities-in-category/opportunities-in-category.component';
import { PagesWithDuplicateTitleTitlesComponent } from './dialogs/pages-with-duplicate-title/blocks/titles/pages-with-duplicate-title-titles.component';
import { PagesWithDuplicateTitlePagesComponent } from './dialogs/pages-with-duplicate-title/blocks/pages/pages-with-duplicate-title-pages.component';
import { PagesFromSeoIssuesComponent } from './dialogs/pages-from-seo-issues/pages-from-seo-issues.component';
import { FormsModule } from '@angular/forms';

// Import shared components and modules
import { SharedModule } from '@client/ng2/shared/shared.module';
import { ChartsModule } from '@client/app/modules/charts/charts.module';
import { LayoutModule, MonEventTriggerModule, MonTableSortModule, TableModule } from '@monsido/angular-shared-components';
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { ExportModule } from '@client/app/modules/export/export.module';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';
import { TablePolicyTypeComponent } from '@monsido/modules/table-policy-type/table-policy-type.component';
import { DoughnutComponent } from '@client/app/modules/charts/components/doughnut.component';
import { QuickHelpComplianceStatusModule } from '@client/app/components/quick-help-compliance-status/quick-help-compliance-status.module';
import { ExtensionModule } from '@client/app/modules/extension/extension.module';
import { ActiveFeaturePipe } from '@monsido/core/pipes/active-feature/active-feature.pipe';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        SeoSummaryComponent,
        SeoIssuesComponent,
        SeoPagesComponent,
        PagesSeoIssuesComponent,
        SeoDialogPagesWithDuplicateTitleComponent,
        SeoSummaryCommonOpportunitiesComponent,
        SeoIssuesBtnGroupComponent,
        SeoSummaryOpportunitiesInCategoryComponent,
        PagesWithDuplicateTitleTitlesComponent,
        PagesWithDuplicateTitlePagesComponent,
        PagesFromSeoIssuesComponent,
    ],
    imports: [
        FormsModule,
        ExportModule,
        TranslateModule,
        ComponentsModule,
        UpgradePipeModule,
        CommonModule,
        UIRouterModule,
        SeoRoutingModule,
        SharedModule,
        ChartsModule,
        TableModule,
        NgbModule,
        LayoutModule,
        ModalsDirectivesModule,
        TablePolicyTypeComponent,
        MonEventTriggerModule,
        DoughnutComponent,
        QuickHelpComplianceStatusModule,
        MonTableSortModule,
        ExtensionModule,
        ActiveFeaturePipe,
    ],
    providers: [],
})
export class SeoModule {}
